/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  Article,
  ArticleCreateUpdateRequest,
  ModeratorsArticlesListParams,
  PaginatedArticleList
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * List every article on the platform. Optional filters: `category` and `targetCompanyId` (to find articles targeted at a specific company). Paginated.
 * @summary List articles (moderator)
 */
export const moderatorsArticlesList = (
    params?: ModeratorsArticlesListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedArticleList>(
      {url: `/api/v1/moderators/articles/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsArticlesListQueryKey = (params?: ModeratorsArticlesListParams,) => {
    return [`/api/v1/moderators/articles/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsArticlesListQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsArticlesList>>, TError = unknown>(params?: ModeratorsArticlesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsArticlesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsArticlesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsArticlesList>>> = ({ signal }) => moderatorsArticlesList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsArticlesList>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsArticlesListQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsArticlesList>>>
export type ModeratorsArticlesListQueryError = unknown

/**
 * @summary List articles (moderator)
 */
export const useModeratorsArticlesList = <TData = Awaited<ReturnType<typeof moderatorsArticlesList>>, TError = unknown>(
 params?: ModeratorsArticlesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsArticlesList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsArticlesListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Create a new article. `pdfFile` is multipart-uploaded and stored in private S3 storage (PDF only, max 10 MB; 400 `{error}` otherwise). `targetCompanyIds` is optional; omit (or send empty) to broadcast to every approved company.
 * @summary Create article (moderator)
 */
export const moderatorsArticlesCreate = (
    articleCreateUpdateRequest: ArticleCreateUpdateRequest,
 ) => {
      
      
      return customInstance<Article>(
      {url: `/api/v1/moderators/articles/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: articleCreateUpdateRequest
    },
      );
    }
  


export const getModeratorsArticlesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsArticlesCreate>>, TError,{data: ArticleCreateUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsArticlesCreate>>, TError,{data: ArticleCreateUpdateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsArticlesCreate>>, {data: ArticleCreateUpdateRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsArticlesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsArticlesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsArticlesCreate>>>
    export type ModeratorsArticlesCreateMutationBody = ArticleCreateUpdateRequest
    export type ModeratorsArticlesCreateMutationError = unknown

    /**
 * @summary Create article (moderator)
 */
export const useModeratorsArticlesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsArticlesCreate>>, TError,{data: ArticleCreateUpdateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsArticlesCreate>>,
        TError,
        {data: ArticleCreateUpdateRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsArticlesCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Moderator-side article CRUD.

Lives under /api/v1/moderators/articles/. Accepts both JSON and multipart
so a moderator can upload a PDF directly (FileField) or POST metadata
only. The PDF (PDF only, max 10 MB) is stored in private storage and
exposed through short-lived signed URLs.

The company-facing `ArticleViewSet.list` filters by target_companies; this
viewset does not — moderators see every article regardless of targeting.
 * @summary Retrieve article (moderator)
 */
export const moderatorsArticlesRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<Article>(
      {url: `/api/v1/moderators/articles/${id}/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsArticlesRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/moderators/articles/${id}/`] as const;
    }

    
export const getModeratorsArticlesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsArticlesRetrieve>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsArticlesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsArticlesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsArticlesRetrieve>>> = ({ signal }) => moderatorsArticlesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsArticlesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsArticlesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsArticlesRetrieve>>>
export type ModeratorsArticlesRetrieveQueryError = unknown

/**
 * @summary Retrieve article (moderator)
 */
export const useModeratorsArticlesRetrieve = <TData = Awaited<ReturnType<typeof moderatorsArticlesRetrieve>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsArticlesRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsArticlesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Moderator-side article CRUD.

Lives under /api/v1/moderators/articles/. Accepts both JSON and multipart
so a moderator can upload a PDF directly (FileField) or POST metadata
only. The PDF (PDF only, max 10 MB) is stored in private storage and
exposed through short-lived signed URLs.

The company-facing `ArticleViewSet.list` filters by target_companies; this
viewset does not — moderators see every article regardless of targeting.
 * @summary Update article (moderator)
 */
export const moderatorsArticlesUpdate = (
    id: number,
    articleCreateUpdateRequest: ArticleCreateUpdateRequest,
 ) => {
      
      
      return customInstance<Article>(
      {url: `/api/v1/moderators/articles/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: articleCreateUpdateRequest
    },
      );
    }
  


export const getModeratorsArticlesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsArticlesUpdate>>, TError,{id: number;data: ArticleCreateUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsArticlesUpdate>>, TError,{id: number;data: ArticleCreateUpdateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsArticlesUpdate>>, {id: number;data: ArticleCreateUpdateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsArticlesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsArticlesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsArticlesUpdate>>>
    export type ModeratorsArticlesUpdateMutationBody = ArticleCreateUpdateRequest
    export type ModeratorsArticlesUpdateMutationError = unknown

    /**
 * @summary Update article (moderator)
 */
export const useModeratorsArticlesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsArticlesUpdate>>, TError,{id: number;data: ArticleCreateUpdateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsArticlesUpdate>>,
        TError,
        {id: number;data: ArticleCreateUpdateRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsArticlesUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Moderator-side article CRUD.

Lives under /api/v1/moderators/articles/. Accepts both JSON and multipart
so a moderator can upload a PDF directly (FileField) or POST metadata
only. The PDF (PDF only, max 10 MB) is stored in private storage and
exposed through short-lived signed URLs.

The company-facing `ArticleViewSet.list` filters by target_companies; this
viewset does not — moderators see every article regardless of targeting.
 * @summary Delete article (moderator)
 */
export const moderatorsArticlesDestroy = (
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/articles/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getModeratorsArticlesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsArticlesDestroy>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsArticlesDestroy>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsArticlesDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  moderatorsArticlesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsArticlesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsArticlesDestroy>>>
    
    export type ModeratorsArticlesDestroyMutationError = unknown

    /**
 * @summary Delete article (moderator)
 */
export const useModeratorsArticlesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsArticlesDestroy>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsArticlesDestroy>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getModeratorsArticlesDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    